import { Card, CardHeader } from '@mui/material'
import { memo } from 'react'
import { Trans } from 'react-i18next'

const Note = ({ t }) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.note')}
        subheader={<Trans i18nKey='earn-via.note-desc' />}
        sx={{ p: 0 }}
      />
    </Card>
  )
}

export default memo(Note)
